import { useState, useEffect } from "react";
import { useRequest } from "ahooks";
import { message } from "antd";
import { PayChannelItem, PayChannelProps } from "@/index";
import { useTranslation } from "react-i18next";

async function getCurrency(
  channel: string,
  getChannelApiUrl: string
): Promise<string> {
  return await fetch(`${getChannelApiUrl}/currency?channel=${channel}`, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  }).then((res) => res.json());
}

async function getPayChannel(
  appId: string,
  getChannelApiUrl: string
): Promise<PayChannelItem[]> {
  let res;
  try {
    res = await fetch(`${getChannelApiUrl}/payChannel`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "app-id": appId,
      },
    }).then((res) => res.json());

    res.data = res.data.filter((item: any) => item.state);

    for await (const item of res.data) {
      try {
        const result: any = await getCurrency(item.name, getChannelApiUrl);
        item.currencys = result.data;
        item.currency = result.data[0].currencyId;
      } catch (error) { }
    }
  } catch (error) { }

  return res;
}

export const usePayChannel = ({
  appId = "",
  getChannelApiUrl = "",
}: PayChannelProps) => {
  const [payChannel, setPayChannel] = useState<PayChannelItem[]>(() => {
    return JSON.parse(localStorage.getItem("payChannel") || "[]");
  });
  const { t } = useTranslation();

  const { run, loading } = useRequest(
    () => getPayChannel(appId, getChannelApiUrl),
    {
      manual: true,
      cacheKey: "payChannel",
      onSuccess: (res: any) => {
        const result = res?.data;
        if (result) {
          localStorage.setItem("payChannel", JSON.stringify(result));
          setPayChannel(result);
        }
      },
      onError: (error) => {
        message.error(t("获取支付渠道失败，请稍后重试"));
        setPayChannel([]);
        localStorage.setItem("payChannel", JSON.stringify([]));
        console.error("Failed to fetch payment channels:", error);
      },
    }
  );

  useEffect(() => {
    if (appId) run();
  }, [appId]);

  return {
    loading,
    payChannel,
    setPayChannel,
  };
};
